import * as React from "react";

interface IProps {
	value: Object;
}

export const JsonPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{JSON.stringify(props.value)}</span>
	);
};
